import { inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { DataResponse } from '../../core/models/data-response';
import { ConfigService } from '../../core/services/config/config.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { RequestDetailNote } from '../models/request-detail';

export interface CreateNoteRequest {
  patientPortalUserRequestId: number;
  createdByPatientPortalAdminUserId: number;
  note: string;
}

@Injectable({
  providedIn: 'root',
})
export class PatientPortalUserRequestNotesService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;
  private readonly endpoint = `${this.config.adminDashboardApiUrl}/PatientPortalUserRequestNotes`;

  createNote(request: CreateNoteRequest): Observable<RequestDetailNote> {
    return this.utilityService
      .postRequest<DataResponse<RequestDetailNote>>(this.endpoint, request, false, false, true)
      .pipe(map((response) => response.result));
  }
}
